import { FC } from 'react';
import { Box } from '@mui/material';
import { toPersistedInlineRichTextHtml } from 'shared/utils/richText';

interface RichTextInlineViewProps {
  content: string;
  dataQa?: string;
}

/**
 * One line of rich text, read-only, inside other text (an `OPTION_SELECTION`
 * option label next to its checkbox, PT-7250): inline formatting and colour,
 * no blocks. A label migrated from plain text (`a&lt;b`) shows as `a<b`.
 */
export const RichTextInlineView: FC<RichTextInlineViewProps> = ({ content, dataQa }) => (
  <Box
    component='span'
    data-qa={dataQa}
    sx={{ overflowWrap: 'break-word', wordBreak: 'break-word' }}
    dangerouslySetInnerHTML={{ __html: toPersistedInlineRichTextHtml(content) }}
  />
);

export default RichTextInlineView;
